
import { mapState, mapActions, mapGetters } from "vuex";
export default
  {
    components: {},
    props: {
      chaxunData: {
        type: Object,
        default: () => ({
          idNumber: "",
          name: "",
          representativeName: "",
          representativePhone: "",
          uuid: "",
          createdAt: 0
        })
      }
    },
    data() { return {} },
    computed: {},
    watch: {},
    created() { },
    mounted() {

    },
    destroyed() { },
    methods: {
      ...mapActions("qiyeshiming", ["setStep","hideMode2"]),
    }
  };